<script>
  import { beforeUpdate } from 'svelte';
  import { slide } from 'svelte/transition';
  
  export let type = 'info';
  export let dismissable = false;
  let classNames = 'alert';
  let typeClassMap = {};
  typeClassMap['success'] = 'alert-success';
  typeClassMap['error']   = 'alert-danger';
  typeClassMap['info']    = 'alert-info';
  typeClassMap['help']    = 'alert-info';
  typeClassMap['warning'] = 'alert-warn';

  beforeUpdate(() => {
    classNames = 'alert';
    const permissableTypes = [
      'success',
      'error',
      'info',
      'help',
      'warning'
    ];
    
    if (permissableTypes.includes(type)) {
      classNames += ` ${typeClassMap[type]}`;
    }
  });
</script>
<style></style>

<div class={classNames} transition:slide>
  <slot></slot>
  {#if dismissable}
  <span class="btn-dismiss">
    <i class="fas fas-close"></i>
  </span>
  {/if}
</div>